import React from "react";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { VDBText } from "..";
import { SpaceType } from "../Spacer/types";

interface ProgressBarProps {
  progress: number; // value between 0 and 100
  height?: number;
  backgroundColor?: string;
  progressColor?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  height = 6,
  backgroundColor,
  progressColor,
}) => {
  const { theme, typography } = useScreenOptionsHooks();
  return (
    <Container>
      <ProgressContainer
        height={height}
        backgroundColor={backgroundColor ? backgroundColor : theme["core-03"]}
      >
        <Progress
          width={`${Math.min(Math.max(progress, 0), 100)}%`}
          progressColor={progressColor ? progressColor : theme["success-01"]}
        />
      </ProgressContainer>
      <ProgressText>
        <VDBText color={theme["core-06"]} type={typography["Minor-M"]}>
          {progress}%
        </VDBText>
      </ProgressText>
    </Container>
  );
};

const Container = styled.View<{
  height: number;
  backgroundColor: string;
}>`
  gap: ${SpaceType.ExtraSmall}px;
`;

const ProgressContainer = styled.View<{
  height: number;
  backgroundColor: string;
}>`
  width: 100%;
  border-radius: 100px;
  overflow: hidden;
  height: ${({ height }) => height}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const Progress = styled.View<{
  width: number;
  progressColor: string;
}>`
  height: 100%;
  border-radius: 100px;
  width: ${({ width }) => width};
  background-color: ${({ progressColor }) => progressColor};
`;

const ProgressText = styled.View``;

export default ProgressBar;
